import React from "react";
import SidebarMenu from "./SidebarMenu";
import Layout, { Content } from "antd/es/layout/layout";
import { Outlet } from "react-router-dom";
import UtilityPanel from "./UtilityPanel";

export const HomePageLayout: React.FC = () => {
  return (
    <Layout>
      <SidebarMenu />
      <Content
        style={{
          display: "flex",
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#FFFFFF",
        }}
      >
        <Outlet />
      </Content>
      <UtilityPanel />
    </Layout>
  );
};
